<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M21.875 11.9792C21.8786 13.3541 21.5574 14.7103 20.9375 15.9375C20.2025 17.4081 19.0727 18.645 17.6744 19.5097C16.2762 20.3744 14.6648 20.8327 13.0208 20.8334C11.646 20.8369 10.2897 20.5157 9.0625 19.8959L3.125 21.875L5.10417 15.9375C4.4843 14.7103 4.16308 13.3541 4.16667 11.9792C4.1673 10.3352 4.62564 8.72383 5.49033 7.3256C6.35503 5.92737 7.59193 4.7975 9.0625 4.06253C10.2897 3.44267 11.646 3.12145 13.0208 3.12503H13.5417C15.7129 3.24481 17.7636 4.16124 19.3012 5.69884C20.8388 7.23644 21.7552 9.28717 21.875 11.4584V11.9792Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
